<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Account Settings/</span> Account
        </h4>

        <mat-card>
            <mat-card-header class="mt-3">
                <mat-icon>person</mat-icon>Profile Details
            </mat-card-header>

            <hr class="my-0 mt-3 mb-3" />
            <mat-card-content>
                <form [formGroup]="myProfileForm" (ngSubmit)="onSubmit()">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>First Name</mat-label>
                                    <input matInput formControlName="FirstName" (change)="onFieldChange('fn')"
                                        name="FirstName" id="FirstName" required
                                        [ngClass]="{'is-invalid':submitted && forms.FirstName.errors}" autofocus>

                                    <mat-error *ngIf="submitted && forms.FirstName.errors" class="invalid-feedback">
                                        <div *ngIf="forms.FirstName.errors.required">FirstName is required</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline" id="byid">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="Email" name="Email"
                                        (change)="onFieldChange('email')" id="Email" required
                                        [ngClass]="{'is-invalid':submitted && forms.Email.errors}" autofocus
                                        readonly="true">

                                    <mat-error *ngIf="submitted && forms.Email.errors && forms.Email.touched"
                                        class="invalid-feedback">
                                        <div *ngIf="forms.Email.errors.required">Email is required</div>
                                        <div *ngIf="forms.Email.errors.email">Email must be a valid email address</div>
                                        <!-- <div *ngIf="forms.Email.errors.pattern">The Email is not valid email address
                                        </div> -->
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Zip Code</mat-label>
                                    <input matInput formControlName="ZipCode" name="ZipCode" id="ZipCode"
                                        (change)="onFieldChange('zip');onZipCodeChange($event)" required
                                        [ngClass]="{'is-invalid':submitted && forms.ZipCode.errors}" OnlynumberDirective
                                        autofocus>
                                    <!-- <input matInput formControlName="ZipCode" name="ZipCode" id="ZipCode" (change)="onFieldChange('zip')"
                                        (mouseout)="onZipCodeChange()" required
                                        [ngClass]="{'is-invalid':submitted && forms.ZipCode.errors}" OnlynumberDirective
                                        autofocus> -->
                                    <mat-error *ngIf="submitted  && forms.ZipCode.errors" class="invalid-feedback">
                                        <div *ngIf="forms.ZipCode.errors.required">ZipCode is required</div>
                                        <div *ngIf="forms.ZipCode.errors.minlength">Mininmum length is 5</div>
                                        <div *ngIf="forms.ZipCode.errors.maxlength">Maximum length is 5</div>
                                    </mat-error>
                                </mat-form-field>

                                <!-- {{this.myProfileForm.value.PhoneNumber}} -->

                                <mat-form-field appearance="outline">
                                    <mat-label>State</mat-label>                                    
                                    <mat-select formControlName="State" name="state" id="state"
                                        (selectionChange)="onFieldChange('state')"
                                        [ngClass]="{'is-invalid':submitted && forms.State.errors}" required autofocus>
                                        <mat-option *ngFor="let state of State" [value]="state.stateId">
                                            {{ state.state }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="submitted && forms.State.errors" class="invalid-feedback">
                                        <div *ngIf="forms.State.errors.required"> State is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>State</mat-label>                                    
                                    <mat-select #state formControlName="State" name="state" id="state" required
                                        (selectionChange)="onFieldChange('state')"
                                        [ngClass]="{'is-invalid':submitted && forms.State.errors}" autofocus>
                                        <mat-option *ngFor="let state of State" [value]="state.name">
                                            {{ state.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="submitted && forms.State.errors" class="invalid-feedback">
                                        <div *ngIf="forms.State.errors.required">State is required</div>
                                    </mat-error>
                                </mat-form-field> -->

                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>Country</mat-label>
                                    <input matInput formControlName="Country" name="Country" id="Country" required
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}" autofocus> -->
                                <!-- <mat-select #country formControlName="Country" name="country" id="country" required
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}"
                                        (change)="onCountryChange($event)" autofocus>
                                        <mat-option *ngFor="let country of countries" [value]="country.name">
                                            {{ country.flag }}&nbsp;&nbsp;{{ country.name }}
                                        </mat-option>
                                    </mat-select> -->

                                <!-- <select matNativeControl id="Country" formControlName="Country" name="Country"
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}" required>
                                        <option value="">Select</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Bangladesh">Bangladesh</option>
                                        <option value="China">China</option>
                                        <option value="France">France</option>
                                        <option value="Germany">Germany</option>
                                        <option value="India">India</option>
                                        <option value="Mexico">Mexico</option>
                                        <option value="Philippines">Philippines</option>
                                        <option value="Russia">Russian Federation</option>
                                        <option value="South Africa">South Africa</option>
                                        <option value="Thailand">Thailand</option>
                                        <option value="Turkey">Turkey</option>
                                        <option value="Ukraine">Ukraine</option>
                                        <option value="United Arab Emirates">United Arab Emirates</option>
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="United States">United States</option>
                                    </select>  -->
                                <!-- <mat-error *ngIf="submitted && forms.Country.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Country.errors.required">Country is required</div>
                                    </mat-error> 
                                </mat-form-field>-->
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="adminControls">

                                <mat-form-field appearance="outline">
                                    <mat-label>Last Name</mat-label>
                                    <input matInput formControlName="LastName" name="LastName" id="LastName" required
                                        (change)="onFieldChange('ln')"
                                        [ngClass]="{'is-invalid':submitted && forms.LastName.errors}" autofocus>

                                    <mat-error *ngIf="submitted && forms.LastName.errors" class="invalid-feedback">
                                        <div *ngIf="forms.LastName.errors.required">LastName is required</div>
                                    </mat-error>
                                </mat-form-field>


                                <mat-form-field appearance="outline">
                                    <mat-label>Organization</mat-label>
                                    <input matInput formControlName="organization" name="organization" id="organization"
                                        (change)="onFieldChange('orgn')" required
                                        [ngClass]="{'is-invalid':submitted && forms.organization.errors}" autofocus>

                                    <mat-error *ngIf="submitted && forms.organization.errors" class="invalid-feedback">
                                        <div *ngIf="forms.organization.errors.required">Organization is required</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Address </mat-label>
                                    <input matInput formControlName="Address" name="Address" id="Address" required
                                        (change)="onFieldChange('address')"
                                        [ngClass]="{'is-invalid':submitted && forms.Address.errors}" autofocus>

                                    <mat-error *ngIf="submitted && forms.Address.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Address.errors.required">Address is required</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput type="tel" formControlName="PhoneNumber" name="PhoneNumber"
                                        placeholder="XXX-XXX-XXXX" id="PhoneNumber" (keypress)="onPress($event)"
                                        (change)="onFieldChange('phone')" required
                                        [ngClass]="{'is-invalid':submitted && forms.PhoneNumber.errors}"
                                        autocomplete="doNotAutoComplete" appPhoneMask appNumericOnly>
                                    <mat-error *ngIf="submitted && forms.PhoneNumber.errors" class="invalid-feedback">
                                        <div *ngIf="forms.PhoneNumber.errors.required">Phone Number is required</div>
                                        <div *ngIf="forms.PhoneNumber.errors.pattern">Please, Enter 10 digit Mobile
                                            Number</div>
                                    </mat-error>
                                </mat-form-field>
                                <!-- {{this.myProfileForm.value.ZipCode}} -->
                                <!-- <mat-form-field appearance="outline" style="visibility: hidden;">
                                    <input matInput formControlName="Address">
                                </mat-form-field> -->
                            </div>
                        </div>
                    </div>
                    <alert></alert>
                    <mat-card-actions>
                        <button type="submit" mat-raised-button style="margin-left:40px;" class="button"
                            [disabled]="isLoading">
                            <!-- <mat-icon class="icons" *ngIf="status==false">edit </mat-icon> -->
                            <span class="material-symbols-outlined" *ngIf="status==false">
                                edit
                            </span>
                            <mat-icon class="icons" *ngIf="status==true" style="margin-right: 30px;">save</mat-icon>
                            {{status==false ? 'Edit' :'Save Changes' }}
                        </button>
                        <button mat-raised-button *ngIf="status" (click)="reset()" class="buttonReset">
                            Cancel</button>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>


<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>